export type ThemeMode = 'light' | 'dark';

const LS_KEY = 'toscana.theme.v1';

function systemPref(): ThemeMode {
  if (typeof matchMedia === 'undefined') return 'light';
  return matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function load(): ThemeMode {
  try {
    const v = localStorage.getItem(LS_KEY);
    if (v === 'light' || v === 'dark') return v;
  } catch { /* ignore */ }
  return systemPref();
}

let _theme = $state<ThemeMode>(load());

export const theme = {
  get value() { return _theme; },
  set value(v: ThemeMode) {
    _theme = v;
    try { localStorage.setItem(LS_KEY, v); } catch { /* ignore */ }
    apply(v);
  },
  toggle() {
    theme.value = _theme === 'light' ? 'dark' : 'light';
  },
};

export function applyTheme(mode: ThemeMode = _theme) {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', mode);
}

function apply(mode: ThemeMode) {
  applyTheme(mode);
}

applyTheme(_theme);
